import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=ca5050ce&"
import script from "./LogoutBtn.vue?vue&type=script&lang=js&"
export * from "./LogoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./LogoutBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports